import clsx from "clsx";
import { useTranslation } from "react-i18next";

import classes from "../../styles.module.scss";

import { Typography } from "@components/atoms/typography";
import type { ITablePerPageSelectorProps } from "@components/organisms/pageTable";
import { Icon } from "@components/atoms/icons";
import {
  Popover,
  PopoverContent,
  PopoverMenuItem,
  PopoverTrigger,
} from "@/components/organisms/popover";

const perPageOptions: number[] = [5, 10, 15, 20, 30, 50, 100];

export function TablePerPageSelector({
  perPage,
  onResultPerPageChange,
}: ITablePerPageSelectorProps) {
  const { t } = useTranslation("common");

  return (
    <div className={clsx(classes.pageTable__perPageSelector, "gap-m2")}>
      <Typography>{`${t("display_page_count")}: `}</Typography>
      <Popover>
        <PopoverTrigger asChild>
          <div
            className={clsx([
              classes.pageTable__perPageSelector,
              "cursor-pointer",
            ])}
          >
            <Typography>{perPage}</Typography>
            <Icon name={"AltArrowDown"} />
          </div>
        </PopoverTrigger>
        <PopoverContent>
          {perPageOptions.map((item) => (
            <PopoverMenuItem
              onClick={() => {
                onResultPerPageChange(item);
              }}
              key={item}
            >
              {item}
            </PopoverMenuItem>
          ))}
        </PopoverContent>
      </Popover>
    </div>
  );
}
